import useWatermark from '../../../es/_hooks/useWatermark';
export default useWatermark;
